import React, { useEffect, useState } from 'react';
import { AuthContextProvider, useAuth } from './context/AuthContextProvider';
import { ErrorBoundary } from 'react-error-boundary';

import { LoadingStatus } from './context/AppContextModels';
import { ErrorFallback } from './generic-components/ErrorFallback';

import { AppRouter } from './AppRouter';
import { BrowserRouter} from 'react-router-dom'
import { createKatalTimerStopWatch, stopAndCaptureTimeMetricsWithBasicAttributes} from "src/katalMetrics/metricsHelperMethods"
import { AgentChatProvider } from './Ateam-BI/AutoMate/context/AgentChatProvider';
import { PersonaProvider } from './Ateam-BI/AutoMate/context/PersonaContext';



export const App: React.FC = () => {
    const [inIframe, setInIframe] = useState(window.self !== window.top)
    return (
        <>
            <ErrorBoundary
                FallbackComponent={ErrorFallback}
                onReset={() => {
                    window.location.reload();
                }}
            >
                <BrowserRouter>
                <AuthContextProvider>
                    <PersonaProvider>
                        <AgentChatProvider>
                            <AppRouter/>
                        </AgentChatProvider>
                    </PersonaProvider>
                </AuthContextProvider>
            </BrowserRouter>
            </ErrorBoundary>
        </>
    );

}

export default App;
